import React from 'react';
import Badge from '../common/Badge';
import { formatDateTime, formatCurrency } from '../../utils/formatters';
import { STATUS_COLORS, DIRECTION_COLORS } from '../../utils/constants';

/**
 * 거래 내역 카드 컴포넌트
 * 주문 내역과 체결 내역 모두 표시 가능
 */
const TradeCard = ({ trade, showProfit = false }) => {
  const isBuy = trade.direction === 'Buy';
  const directionColor = DIRECTION_COLORS[trade.direction];
  const statusColor = STATUS_COLORS[trade.status];

  return (
    <div className="bg-gray-800 rounded-lg p-4 mb-3 border border-gray-700">
      {/* 헤더: 시간과 상태 */}
      <div className="flex justify-between items-start mb-3">
        <div>
          <div className="text-xs text-gray-500">
            {trade.executeTime ? formatDateTime(trade.executeTime) : formatDateTime(trade.orderTime)}
          </div>
        </div>
        <Badge variant={statusColor}>{trade.status}</Badge>
      </div>

      {/* 종목 및 방향 */}
      <div className="mb-3">
        <h3 className="text-lg font-bold">{trade.symbol}</h3>
        <span className={`text-sm font-semibold ${directionColor}`}>
          {isBuy ? '매수' : '매도'}
        </span>
      </div>

      {/* 거래 정보 그리드 */}
      <div className="grid grid-cols-2 gap-3 text-sm mb-3">
        <div>
          <div className="text-gray-500 text-xs mb-1">
            {trade.executeTime ? '체결가격' : '주문가격'}
          </div>
          <div className="font-semibold">
            {trade.executedPrice || trade.orderPrice}
          </div>
        </div>
        <div>
          <div className="text-gray-500 text-xs mb-1">
            {trade.executeTime ? '체결수량' : '주문수량'}
          </div>
          <div className="font-semibold">
            {trade.executedQuantity || trade.orderQuantity}계약
          </div>
        </div>

        {/* 수수료 (체결 내역에만 표시) */}
        {trade.commission !== undefined && (
          <div>
            <div className="text-gray-500 text-xs mb-1">수수료</div>
            <div className="font-semibold">{formatCurrency(trade.commission)}</div>
          </div>
        )}

        {/* 손익 (체결 내역에만 표시) */}
        {showProfit && trade.profitLoss !== undefined && trade.profitLoss !== null && (
          <div>
            <div className="text-gray-500 text-xs mb-1">손익</div>
            <div className={`font-bold ${trade.profitLoss >= 0 ? 'text-green-500' : 'text-red-500'}`}>
              {formatCurrency(trade.profitLoss)}
            </div>
          </div>
        )}
      </div>

      {/* 주문번호 */}
      <div className="text-xs text-gray-600 pt-3 border-t border-gray-700">
        주문번호: {trade.id}
      </div>
    </div>
  );
};

export default TradeCard;
